import { render } from "./loader1.vue?vue&type=template&id=74db59a1"
import script from "./loader1.vue?vue&type=script&lang=js"
export * from "./loader1.vue?vue&type=script&lang=js"

import "./loader1.vue?vue&type=style&index=0&id=74db59a1&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__